import { Form, Modal } from "antd";
import React from "react";
import { CreateSoilPointPollutantDto } from "../../../api";
import { soilPointPollutantsColumns } from "../form/columns";

interface SoilPointPollutantFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateSoilPointPollutant: (values: CreateSoilPointPollutantDto) => void;
}

export const SoilPointPollutantForm: React.FC<SoilPointPollutantFormProps> = ({ visible, setVisible, onCreateSoilPointPollutant }) => {
  const [form] = Form.useForm<CreateSoilPointPollutantDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateSoilPointPollutant}>
        {soilPointPollutantsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
